/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatsMitmItem } from './StatsMitmItem';
import {
    StatsMitmItemFromJSON,
    StatsMitmItemFromJSONTyped,
    StatsMitmItemToJSON,
    StatsMitmItemToJSONTyped,
} from './StatsMitmItem';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetStatsMitm200Response
 */
export interface GetStatsMitm200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetStatsMitm200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetStatsMitm200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<StatsMitmItem>}
     * @memberof GetStatsMitm200Response
     */
    result: Array<StatsMitmItem>;
}

/**
 * Check if a given object implements the GetStatsMitm200Response interface.
 */
export function instanceOfGetStatsMitm200Response(value: object): value is GetStatsMitm200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function GetStatsMitm200ResponseFromJSON(json: any): GetStatsMitm200Response {
    return GetStatsMitm200ResponseFromJSONTyped(json, false);
}

export function GetStatsMitm200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatsMitm200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': ((json['result'] as Array<any>).map(StatsMitmItemFromJSON)),
    };
}

export function GetStatsMitm200ResponseToJSON(json: any): GetStatsMitm200Response {
    return GetStatsMitm200ResponseToJSONTyped(json, false);
}

export function GetStatsMitm200ResponseToJSONTyped(value?: GetStatsMitm200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': ((value['result'] as Array<any>).map(StatsMitmItemToJSON)),
    };
}

